import React from "react";
import { useAuth } from "@/lib/auth";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";
import NotificationsBell from "@/components/layout/NotificationsBell";
import { Search } from "lucide-react";

export default function Topbar() {
  const { user } = useAuth();
  const { data: company } = useQuery({
    queryKey: ["company"],
    queryFn: () => api.get("/company").then((r) => r.data).catch(() => null),
    enabled: !!user && user.role !== "super_admin",
  });

  return (
    <div className="hidden lg:flex sticky top-0 z-30 items-center gap-3 px-6 lg:px-10 h-14 border-b border-border backdrop-blur-xl bg-background/80">
      <div className="flex items-center gap-2 text-xs text-muted-foreground">
        {company?.logo_url && <img src={company.logo_url} alt="" className="h-5 rounded-sm" onError={(e) => e.target.style.display = "none"} />}
        <span className="uppercase tracking-widest font-bold text-[10px]">{company?.name || "LeadifyCRM"}</span>
      </div>
      <div className="ml-auto flex items-center gap-3">
        <div className="hidden xl:flex items-center gap-2 px-3 py-1.5 border border-border rounded-sm bg-secondary/30 text-xs text-muted-foreground w-64">
          <Search className="h-3 w-3" />
          <span>Search coming soon…</span>
        </div>
        <NotificationsBell />
      </div>
    </div>
  );
}
